<template>
  <b-container class="form-container bg-white shadow">
    <b-col class="pb-3 pb-md-0" cols="12" md="6" offset-md="3">
      <h2 class="py-3">Password Reset</h2>
      <b-form @submit.prevent="onSubmit">
        <ValidationObserver ref="observer">
          <NewAccountInputs vertical newPassword :account="passwordReset" />
        </ValidationObserver>
        <span v-for="error in resetErrors" :key="error.code" class="d-block invalid-feedback mb-3">
          {{error.description}}
        </span>
        <b-button variant="outline-primary" type="submit" pill block :disabled="submitting" aria-label="Submit password reset">
          Submit
        </b-button>
      </b-form>
    </b-col>
  </b-container>
</template>

<script>
import FormSubmit from '@/mixins/FormSubmit';
import NewAccountInputs from '@/components/account/NewAccountInputs.vue';

export default {
  name: 'PasswordReset',
  components: {
    NewAccountInputs,
  },
  mixins: [FormSubmit],
  data() {
    return {
      passwordReset: {
        email: '',
        password: '',
        passwordResetToken: '',
      },
      resetErrors: [],
    };
  },
  created() {
    this.$router.onReady(this.handleQuery);
  },
  methods: {
    handleQuery() {
      // If user navigated here without token, send them to the home page
      if (!this.$route.query.passwordResetToken) this.$router.push({ name: 'home' });
      this.passwordReset.passwordResetToken = this.$route.query.passwordResetToken;
    },
    async onSubmit() {
      this.submit(
        this.$refs.observer,
        'User/resetPassword',
        this.passwordReset,
      );
    },
    submitSuccess() {
      this.$store.dispatch('User/getUserInfo').then(() => {
        this.$router.push({ name: 'dashboard' });
      });
    },
    submitError(error) {
      this.resetErrors = error.response.data;
    },
  },
};
</script>
